import * as THREE from 'three';
import { formatDieValue, getDie } from './dice';
import { paintDieFace } from './dieFaceSkin';

export {
  PORTAL_TRANSIT_MS,
  PORTAL_ENTRY_MS,
  getPortalTransitDuration,
} from './portalWarpProfiles';
export { createPortalTunnel } from './portalWarpScene';

export const createTravelDie = (dieId, faceValues = null) => {
  const die = getDie(dieId);
  const values = faceValues?.length === 6 ? faceValues : die.faces;
  const group = new THREE.Group();
  const shape = new THREE.Shape();
  const half = 0.32;
  shape.moveTo(-half, -half);
  shape.lineTo(half, -half);
  shape.lineTo(half, half);
  shape.lineTo(-half, half);
  shape.closePath();
  const geometry = new THREE.ExtrudeGeometry(shape, {
    depth: 0.64,
    steps: 1,
    bevelEnabled: true,
    bevelThickness: 0.035,
    bevelSize: 0.035,
    bevelSegments: 3,
  });
  geometry.translate(0, 0, -0.32);
  group.add(
    new THREE.Mesh(
      geometry,
      new THREE.MeshPhysicalMaterial({
        color: die.body,
        emissive: die.emissive,
        emissiveIntensity: 0.8,
        metalness: die.metalness,
        roughness: die.roughness,
        clearcoat: 1,
      })
    )
  );
  const edgeSource = new THREE.BoxGeometry(0.66, 0.66, 0.66);
  const edges = new THREE.LineSegments(
    new THREE.EdgesGeometry(edgeSource),
    new THREE.LineBasicMaterial({
      color: die.color,
      transparent: true,
      opacity: 0.8,
    })
  );
  edgeSource.dispose();
  group.add(edges);
  const faces = [
    [0, 0, 0.36, 0, 0],
    [0.36, 0, 0, 0, Math.PI / 2],
    [0, 0, -0.36, 0, Math.PI],
    [-0.36, 0, 0, 0, -Math.PI / 2],
    [0, 0.36, 0, -Math.PI / 2, 0],
    [0, -0.36, 0, Math.PI / 2, 0],
  ];
  faces.forEach(([x, y, z, rx, ry], index) => {
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 256;
    const context = canvas.getContext('2d');
    if (!context) return;
    paintDieFace(
      context,
      canvas.width,
      canvas.height,
      values ? formatDieValue(values[index]) : '?',
      die.color,
      die.id
    );
    const texture = new THREE.CanvasTexture(canvas);
    texture.colorSpace = THREE.SRGBColorSpace;
    const label = new THREE.Mesh(
      new THREE.PlaneGeometry(0.6, 0.6),
      new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true,
        depthWrite: false,
      })
    );
    label.position.set(x, y, z);
    label.rotation.set(rx, ry, 0);
    group.add(label);
  });
  group.add(new THREE.PointLight(die.color, 4, 6, 2));
  return group;
};
